module.exports = __webpack_public_path__ + "img/Superb_sword_08.1e287606.png";